import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

export default function PrivacyPage() {
  const { t } = useLanguage();
  const sections = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => [t(`privacy.s${n}t`), t(`privacy.s${n}`)]);

  return (
    <main className="min-h-screen bg-[#FAF8F5] pt-[57px]" data-testid="privacy-page">
      <section className="px-5 md:px-12 pt-20 pb-12 border-b border-border/60">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="font-display font-black tracking-tighter text-4xl md:text-6xl"
          data-testid="privacy-title"
        >
          {t("privacy.title")}
        </motion.h1>
        <p className="mt-3 text-[10px] tracking-[0.3em] text-muted-foreground">{t("privacy.updated").toUpperCase()}</p>
      </section>
      <section className="px-5 md:px-12 py-14 max-w-3xl space-y-10">
        {sections.map(([title, body], i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, ease: EASE }}
            data-testid={`privacy-section-${i + 1}`}
          >
            <h2 className="font-display font-bold tracking-tight text-xl md:text-2xl">
              <span className="font-mono text-xs text-golddark tracking-[0.3em] mr-3">{String(i + 1).padStart(2, "0")}</span>
              {title}
            </h2>
            <p className="mt-3 text-sm text-muted-foreground leading-[1.9]">{body}</p>
          </motion.div>
        ))}
      </section>
    </main>
  );
}
